module.exports = __webpack_public_path__ + "img/home_banner_1.bc576ba4.png";